export default __webpack_public_path__ + "static/media/cp_geo_tl.f7f09986.svg";